"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var components_1 = require("stremio/components");
var Buffering_less_1 = __importDefault(require("./Buffering.less"));
var Buffering = (0, react_1.forwardRef)(function (_a, ref) {
    var className = _a.className, logo = _a.logo, progress = _a.progress;
    var style = (0, react_1.useMemo)(function () {
        return {
            clipPath: "inset(0 ".concat(100 - progress, "% 0 0)"),
        };
    }, [progress]);
    return (react_1.default.createElement("div", { ref: ref, className: (0, classnames_1.default)(className, Buffering_less_1.default['buffering']) },
        react_1.default.createElement(components_1.Image, { className: Buffering_less_1.default['logo'], style: style, src: logo, alt: '', fallbackSrc: require('/assets/images/caroline-owl.png') }),
        react_1.default.createElement(components_1.Image, { className: (0, classnames_1.default)(Buffering_less_1.default['logo'], Buffering_less_1.default['background']), src: logo, alt: '', fallbackSrc: require('/assets/images/caroline-owl.png') })));
});
exports.default = Buffering;
